import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class Hangar01 extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/hangar_01/', 'hangar_01.babylon', window.scene, function (newMeshes, particleSystems) {
      hObject.objectConfigurations(newMeshes)

      // Cristal frontal
      newMeshes[6].material = window.scene.getMaterialByName('materialCristalesEdificio1')
      // Puerta izquierda SsangYong.SsangYong_exterior.Cube.349
      newMeshes[5].material = window.scene.getMaterialByName('materialCristalesEdificio1')
      // Puerta derecha SsangYong.SsangYong_exterior.Cube.390
      newMeshes[4].material = window.scene.getMaterialByName('materialCristalesEdificio1')
      // Cristal posterior
      newMeshes[3].material = window.scene.getMaterialByName('materialCristalesEdificio')
      newMeshes[7].material = window.scene.getMaterialByName('materialCristalesEdificio')

      newMeshes[4].dispose()
      newMeshes[5].dispose()
    })
  }

  elevator (level) {
    console.log('Moviendo el ascensor al nivel ' + level)
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/Hangar01.js